/**
 * @Description 选址地图（/iterate/siteselectionmap）
 */
import { get, post } from '@/common/request/index';


/**
 * 商圈缩略概览（除标签、业态分析外）
 * https://yapi.lanhanba.com/project/546/interface/api/67878
 */
export function businessAreaOverview(params: any) {
  return get('/modelCluster/preview', { ...params });
}


/**
 * /iterate/siteselectionmapb页面的商圈概览
 * https://yapi.lanhanba.com/project/546/interface/api/68333
 */
export function areaOverview(params: any) {
  return post('/modelCluster/overview', { ...params }, {
    needCancel: false
  });
}

/**
 * 周边poi类目列表（包含数量）
 * https://yapi.lanhanba.com/project/511/interface/api/69782
 */
export function surroundPOICategoryList(params: any, config?: any) {
  return post('/surround/poi/level_count', { ...params }, config);
}

/**
 * 周边poi类目列表（包含数量）-分享
 * https://yapi.lanhanba.com/project/546/interface/api/81493
 */
export function surroundSharePOICategoryList(params: any, config?: any) {
  return post('/surround/share/poi/level_count', { ...params }, config);
}


/**
 * 周边类目下的poi数据分页列表
 * https://yapi.lanhanba.com/project/546/interface/api/71070
 */
export function surroundCategoryPOIDataList(params: any, config?: any) {
  return post('/surround/poi/level_page', { ...params }, config);
}

/**
 * 周边类目下的poi数据分页列表-分享
 * https://yapi.lanhanba.com/project/546/interface/api/81486
 */
export function surroundCategorySharePOIDataList(params: any, config?: any) {
  return post('/surround/share/poi/level_page', { ...params }, config);
}

/**
 * 知名品牌门店分页列表
 * https://yapi.lanhanba.com/project/349/interface/api/73191
 */
export function famousBrandDataList(params: any, config?: any) {
  return post('/famous/brand/page', { ...params }, config);
}

/**
 * 竞品品牌分页接口
 * https://yapi.lanhanba.com/project/511/interface/api/73345
 */
export function surroundCompetitorsPagePOIDataList(params: any, config?: any) {
  return post('/surround/poi/competitorsPage', { ...params }, config);
}

/**
 * 竞品品牌分页接口-分享
 * https://yapi.lanhanba.com/project/546/interface/api/81479
 */
export function surroundCompetitorsPageSharePOIDataList(params: any, config?: any) {
  return post('/surround/share/poi/competitorsPage', { ...params }, config);
}

/**
 * 选址地图模型 筛选模型 列表（餐饮/汽车/服装）
 * https://yapi.lanhanba.com/project/462/interface/api/70062
 */
export function getSiteModel() {
  return get('/site_model/screeningList', null, {
    isMock: true,
    mockId: 462,
    mockSuffix: '/api/api',
    needHint: true,
  });
}

/**
 * 为当前用户 将商圈 or 点位 移入/移出收藏夹
 * https://yapi.lanhanba.com/project/546/interface/api/70468
 */
export function handleCollectOfFetch(params: any) {
  return post('/clusterLocationFavor/update', { ...params }, {
    isMock: false,
    mockId: 462,
    mockSuffix: '/api/api',
    needHint: true,
  });
}

/**
 * 获取商圈下点位列表
 * https://yapi.lanhanba.com/project/546/interface/api/70160
 */
export function getAreaPoints(params: any) {
  return post('/modelCluster/mallLocation/list', { ...params }, {
    isMock: false,
    mockId: 546,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * 获取商圈下点位列表
 * https://yapi.lanhanba.com/project/546/interface/api/70209
 */
export function getFavoriteList(params: any) {
  return post('/clusterLocationFavor/folderList', { ...params }, {
    isMock: false,
    mockId: 546,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * 导出pdf（定制化:https://docs.lanhanba.net/fe/html2pdf?name=%2Fcustomization%2Fpdf）
 * https://yapi.lanhanba.com/project/546/interface/api/70818
 */
export function exportModelClusterPDF(params:any) {
  return post(`/modelCluster/export/pdf`, params);
}


/**
 * 导出pdf（异步）（定制化:https://docs.lanhanba.net/fe/html2pdf?name=%2Fcustomization%2Fpdf）
 * https://yapi.lanhanba.com/project/546/interface/api/70993
 * 升级后，接口会对入参做校验，如果传了token就会报错
 */
export function exportModelClusterPDFAsync(params:any) {
  return post(`/standard/pdf/export/asyncV2`, params);
}

/**
 * 创建自定义新增商圈
 * https://yapi.lanhanba.com/project/546/interface/api/70944
 */
export function createCustomModelCluster(params:any) {
  return post(`/modelCluster/createCustom`, params);
}

/**
 * 记录选址地图 市场容量的开关状态、本品牌、竞品品牌、经纬度、地图层级
 * https://yapi.lanhanba.com/project/546/interface/api/71637
 */
export function saveOperation(params:any) {
  return post(`/modelCluster/saveOperation`, params);
}

/**
 * 获取 上一次 选址地图 市场容量的开关状态、本品牌、竞品品牌、经纬度、地图层级
 * https://yapi.lanhanba.com/project/546/interface/api/71644
 */
export function getOperation() {
  return get(`/modelCluster/getOperation`);
}
/*
 * 按钮控制接口
 * https://yapi.lanhanba.com/project/546/interface/api/72225
 */
export function getSelectionMapButton(params) {
  return get(`/modelCluster/selectionMapButton`, params, { needCancel: false });
}
/*
 * 按钮控制接口（分享页用）
 * https://yapi.lanhanba.com/project/546/interface/api/72225
 */
export function getSelectionMapButtonShare(params) {
  return get(`/modelCluster/share/selectionMapButton`, params, { needCancel: false });
}

/**
 * 根据商区id查商区
 * https://yapi.lanhanba.com/project/546/interface/api/72309
 */
export function getBusinessAreaInfo(params:any) {
  return post(`/modelCluster/businessAreInfo`, params);
}

/**
 * 选址地图商圈详情图例
 * https://yapi.lanhanba.com/project/511/interface/api/73275
 */
export function areaDetailLegend(params:any) {
  return post(`/surround/poi/legend`, params);
}


/**
 * 知名品牌列表
 * https://yapi.lanhanba.com/project/349/interface/api/73184
 */
export function getFamousBrandList(params:any) {
  return post(`/famous/brand/list`, params);
}
/**
 * 知名品牌门店地图列表
 * https://yapi.lanhanba.com/project/349/interface/api/73198
 */
export function getFamousBrandMap(params:any) {
  return post(`/famous/brand/shop/map`, params);
}

/**
 * 地铁站点信息
 * https://yapi.lanhanba.com/project/349/interface/api/73324
 */
export function getSubwayStation(params:any) {
  return post(`/subway/searchStation`, params);
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）
 * https://yapi.lanhanba.com/project/511/interface/api/73226
 */
export function surroundArroundCategoryDataList(params: any, config?: any) {
  return post('/surround/model/arroundCategory', { ...params }, config);
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）-分享
 * https://yapi.lanhanba.com/project/532/interface/api/81500
 */
export function surroundShareArroundCategoryDataList(params: any, config?: any) {
  return post('/surround/share/model/arroundCategory', { ...params }, config);
}

/**
 * 选址地图详情-pdf-周边配套 tab接口（返回一二级tab及对应数量）
 * https://yapi.lanhanba.com/project/532/interface/api/78833
 */
export function arroundCategoryPDF(params: any, config?: any) {
  return post('/modelCluster/pdf/model/arroundCategory', { ...params }, config);
}

/**
 * 选址地图详情-pdf-周边配套 poi分页列表
 * https://yapi.lanhanba.com/project/532/interface/api/78840
 * 对应的分类的id (id, parentId, name, codeList, distance)
 * JIAO_TONG(1L, null, "交通", Arrays.asList("150100", "150200", "150500", "150600"), 500),

    DI_TIE(3L, 1L, "地铁", Collections.singletonList("150500"), null),

    QING_GUI(4L, 1L, "轻轨", Collections.singletonList("150600"), null),

    HUO_CHE_ZHAN(5L, 1L, "火车站", Collections.singletonList("150200"), null),

    JI_CHANG(6L, 1L, "机场", Collections.singletonList("150100"), null),

    ZHU_ZHAI(7L, null, "小区", Arrays.asList("120301", "120302", "120303"), 3000),

    BAN_GONG(8L, null, "办公", Arrays.asList("120100", "120201", "120203"), 1500),

    XUE_XIAO(9L, null, "学校", Arrays.asList("141201", "141202", "141203", "141204", "141205", "141206"), 1500),

    YI_LIAO(10L, null, "医疗", Arrays.asList("090101", "090200"), 3000),

    GOU_WU(11L, null, "商业", Arrays.asList("060101", "060102", "060103", "061000"), 1500),

    YIN_HANG(12L, null, "银行", Collections.singletonList("160000"), null),

    JING_QU(13L, null, "景区", Collections.singletonList("110000"), 3000),

    PARK(14L, 13L, "公园", Collections.singletonList("110101"), null),

    ZOO(15L, 13L, "动物园", Collections.singletonList("110102"), null),

    BOTANICAL_GARDEN(16L, 13L, "植物园", Collections.singletonList("110103"), null),

    AQUARIUM(17L, 13L, "水族馆", Collections.singletonList("110104"), null),

    TEMPLE(18L, 13L, "寺庙", Arrays.asList("110205", "110206", "110207"), null),

    SCENIC_SPOTS(19L, 13L, "风景名胜", Collections.singletonList("110200"), null),

    WORLD_HERITAGE(20L, 13L, "世界遗产", Collections.singletonList("110201"), null),

    NATIONAL_SCENIC_SPOTS(21L, 13L, "国家级景区", Collections.singletonList("110202"), null),

    PROVINCIAL_SCENIC_SPOTS(22L, 13L, "省级景区", Collections.singletonList("110203"), null),

    MEMORIAL(23L, 13L, "纪念馆", Collections.singletonList("110204"), null),

    BIE_SHU(24L, 7L, "别墅", Collections.singletonList("120301"), null),

    XIAO_QU(25L, 7L, "住宅小区", Collections.singletonList("120302"), null),

    SU_SHE(26L, 7L, "宿舍", Collections.singletonList("120303"), null),

    XIE_ZI_LOU(27L, 8L, "写字楼",  Arrays.asList("120201", "120203"), null),

    YUAN_QU(28L, 8L, "园区", Collections.singletonList("120100"), null),

    GOU_WU_ZHOGN_XING(29L, 11L, "购物中心", Collections.singletonList("060101"), null),

    BAI_HUO(30L, 11L, "百货商场", Collections.singletonList("060102"), null),

    BU_XING(31L, 11L, "步行街", Collections.singletonList("061000"), null),

    GAO_DENG_YUAN_XIAO(32L, 9L, "高等院校", Collections.singletonList("141201"), null),

    ZHONG_XUE(33L, 9L, "中学", Collections.singletonList("141202"), null),

    XIAO_XUE(34L, 9L, "小学", Collections.singletonList("141203"), null),

    YOU_ER_YUAN(35L, 9L, "幼儿园", Collections.singletonList("141204"), null),

    SAN_JIA_YI_YUAN(36L, 10L, "三甲医院", Collections.singletonList("090101"), null),

    ZHUAN_KE_YI_YUAN(37L, 10L, "专科医院", Collections.singletonList("090200"), null);
 */

export function arroundCategoryPDFPoiPage(params:any, config?: any) {
  return post(`/modelCluster/pdf/poi/page`, params, config);
}

/**
 * 商圈内周边信息
 * https://yapi.lanhanba.com/project/546/interface/api/73380
 */
export function modelClusterSurround(params: any, config?: any) {
  return post('/modelCluster/surround', { ...params }, config);
}
export function modelClusterPcSurround(params: any, config?: any) {
  return post('/modelCluster/pc/surround', { ...params }, config);
}
/**
 * 选址地图-pdf-周边配天：商圈内周边信息
 * https://yapi.lanhanba.com/project/532/interface/api/78819
 */
export function modelClusterSurroundPDF(params: any, config?: any) {
  return post('/modelCluster/pdf/surround', { ...params }, config);
}

/**
 * 选址地图-pdf-热力图
 * https://yapi.lanhanba.com/project/532/interface/api/78854
 */
export function modelClusterHotMapPDF(params: any, config?: any) {
  return post('/modelCluster/pdf/hotMap/population', { ...params }, {
    ...config,
    needCancel: false
  });
}


/**
 * 根据城市id查城市下地铁
 * https://yapi.lanhanba.com/project/546/interface/api/73408
 */
export function getSubwaySubwayNames(params:any, config?: any) {
  return get(`/subway/subwayNames`, params, config);
}

/**
 * 删除自定义新增商圈
 */
export function handleDeleteCustom(params:any) {
  return post(`/modelCluster/deleteCustom`, params);
}

/**
 * 租户主力城市（门店数量排名前十）
 * https://yapi.lanhanba.com/project/546/interface/api/73457
 */
export function getMainCity() {
  return get(`/modelCluster/mainCities`);
}

/**
 * 选址地图-分公司聚合接口
 * https://yapi.lanhanba.com/project/532/interface/api/74171
 */
export function getFilialeData(params?: any) {
  return get(`/modelCluster/brandCompany/shopCount`, { ...(params || {}) }, {
    needCancel: false
  });
}

/**
 * 选址地图-分公司容量聚合
 * https://yapi.lanhanba.com/project/532/interface/api/80093
 */
export function getFilialeCapacityData(params: any) {
  return get(`/modelCluster/brandCompany/capacityCount`, { ...params });
}


/**
 * /iterate/siteselectionmapb页面的 生成中 概览（用户自主创建、还未生成出来的商圈）
 * https://yapi.lanhanba.com/project/532/interface/api/75095
 */
export function initOverview(params: any) {
  return post('/modelCluster/init/overview', { ...params });
}
/**
 * 收藏商圈ID列表
 * https://yapi.lanhanba.com/project/546/interface/api/75949
 */
export function clusterIdList(params: any) {
  return post('/clusterLocationFavor/clusterIdList', params);
}
/**
 * 剩余解锁次数
 * https://yapi.lanhanba.com/project/349/interface/api/75977
 */
export function postModelClusterTimes(params?: any, config?: any) {
  return post('/modelCluster/times', { ...params }, config);
}

/**
 * 解锁
 * https://yapi.lanhanba.com/project/349/interface/api/75984
 */
export function postModelClusterUnLock(params: any, config?: any) {
  return post('/modelCluster/unLock', { ...params }, config);
}

/**
 * 解锁记录
 * https://yapi.lanhanba.com/project/349/interface/api/76005
 */
export function postModelClusterUnlockRecordPage(params?: any, config?: any) {
  return post('/modelCluster/unlockRecordPage', { ...params }, config);
}

/**
 * 导出解锁日志
 * https://yapi.lanhanba.com/project/349/interface/api/76012
 */
export function postModelClusterUnlockRecordExport(params?: any, config?: any) {
  return post('/modelCluster/unlockRecordExport', { ...params }, config);
}
/**
 * 规划统计动态表头
 * https://yapi.lanhanba.com/project/532/interface/api/80317
 */
export function postPlanDynamicColumn(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/dynamicColumn', { ...params }, config);
}

/**
 * 规划统计-全国合计
 * https://yapi.lanhanba.com/project/532/interface/api/80219
 */
export function queryCountryTotal(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/queryCountryTotal', { ...params }, config);
}

/**
 * 规划统计-全国分公司合计
 * https://yapi.lanhanba.com/project/532/interface/api/80205
 */
export function queryBrandCompanyTotal(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/queryBrandCompanyTotal', { ...params }, config);
}

/**
 * 规划统计-省合计
 * https://yapi.lanhanba.com/project/532/interface/api/80226
 */
export function queryCountryGroupTotalByDistrict(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/queryCountryGroupTotalByDistrict', { ...params }, {
    needCancel: true,
    ...config,
  });
}

/**
 * 规划统计-省分公司合计
 * https://yapi.lanhanba.com/project/532/interface/api/80212
 */
export function queryBrandCompanyGroupTotalByDistrict(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/queryBrandCompanyGroupTotalByDistrict', { ...params }, {
    needCancel: true,
    ...config,
  });
}

/**
 * 规划统计-全国省份分页
 * https://yapi.lanhanba.com/project/532/interface/api/80352
 */
export function queryCountryPage(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/queryCountryPage', { ...params }, config);
}

/**
 * 规划统计-全国分公司分页
 * https://yapi.lanhanba.com/project/532/interface/api/80331
 */
export function queryBrandCompanyPage(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/queryBrandCompanyPage', { ...params }, config);
}

/**
 * 规划统计-省区域列表
 * https://yapi.lanhanba.com/project/532/interface/api/80345
 */
export function queryCountryGroupByDistrict(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/queryCountryGroupByDistrict', { ...params }, config);
}

/**
 * 规划统计-分公司区域列表
 * https://yapi.lanhanba.com/project/532/interface/api/80338
 */
export function queryBrandCompanyGroupByDistrict(params?: any, config?: any) {
  return post('/modelCluster/plan/statistics/queryBrandCompanyGroupByDistrict', { ...params }, config);
}

/**
 * https://yapi.lanhanba.com/project/546/interface/api/80191
 * 选址地图-图层配置
 */
export function getLayerSelection(params) {
  return get('/modelCluster/es/selection/layer', params);
}

/**
 * https://yapi.lanhanba.com/project/532/interface/api/80534
 * 查询分公司管辖城市
 */
export function queryCompanyCities(params) {
  return post('/modelCluster/plan/statistics/queryCompanyCities', params);
}

/**
 * 导出-分公司按区聚合
 * https://yapi.lanhanba.com/project/532/interface/api/80562
 */
export function exportBrandCompanyGroupByDistrict(params) {
  return post('/modelCluster/plan/statistics/exportBrandCompanyGroupByDistrict', params);
}

/**
 * 导出-全国按分公司聚合
 * https://yapi.lanhanba.com/project/532/interface/api/80555
 */
export function exportBrandCompanyAllPage(params) {
  return post('/modelCluster/plan/statistics/exportBrandCompanyAllPage', params);
}

/**
 * 导出省份数据
 * https://yapi.lanhanba.com/project/532/interface/api/80541
 */
export function exportCountryAllPage(params) {
  return post('/modelCluster/plan/statistics/exportCountryAllPage', params);
}

/**
 * 导出省份下的区域数据
 * https://yapi.lanhanba.com/project/532/interface/api/80548
 */
export function exportCountryGroupByDistrict(params) {
  return post('/modelCluster/plan/statistics/exportCountryGroupByDistrict', params);
}

/**
 * 选址地图-开店区域分享详情
 * https://yapi.lanhanba.com/project/546/interface/api/80730
 */
export function getModelClusterShareDetail(params) {
  return get('/modelCluster/share/detail', params);
}

/**
 * 选址地图-开店区域概览的分享
 * https://yapi.lanhanba.com/project/532/interface/api/80737
 */
export function getModelClusterShareOverView(params) {
  return post('/modelCluster/share/overview', params);
}

/**
 * 选址地图-开店区域标签
 * https://yapi.lanhanba.com/project/546/interface/api/80786
 */
export function getLabelShareRelations(params) {
  return post('/modelClusterLabel/share/modelCluster/relations', params);
}

/**
 * pc开店区域关联的集客点概览信息
 * https://yapi.lanhanba.com/project/546/interface/api/81626
 */
export function getGatherClient(params) {
  return get(`/plan/spot/modelCluster/overview`, params);
}

/**
 * pc开店区域详情编辑信息
 * https://yapi.lanhanba.com/project/546/interface/api/85735
 */
export function updateAreaDetailInfo(params) {
  return post(`/modelCluster/updateRemark`, { ...(params || {}) });
}


/**
 * 选址地图-搜索地址
 * https://yapi.lanhanba.com/project/546/interface/api/85721
 */
export function multidutySearch(params) {
  return get(`/modelCluster/es/search/address`, { ...(params || {}) });
}


/**
 * 青春版-全国门店
 * https://yapi.lanhanba.com/project/349/interface/api/86218
 */
export function youthMapAllStores() {
  return get(`/youth/map/allStores`);
}
/**
 * 获取拥有权限的城市
 * https://yapi.lanhanba.com/project/349/interface/api/88087
 */
export function getCityPermission() {
  return get(`/youth/map/permission/city`);
}
/**
 * 获取拥有哪些员工的权限
 * https://yapi.lanhanba.com/project/349/interface/api/88094
 */
export function getEmployeePermission() {
  return get(`/youth/map/permission/employee`);
}

/**
 * https://yapi.lanhanba.com/project/616/interface/api/81192
 * POI搜索
 */
export function getPoiSearchResult(params: any) {
  return post(`/youth/map/poi/selection`, { ...params }, {
    needCancel: false
  });
}
